import TopicPage from '../components/TopicPage';

const sections = [
  {
    title: 'Compute',
    icon: '💻',
    cards: [
      {
        icon: '🖥️',
        title: 'EC2',
        level: 'beginner',
        description: 'Elastic Compute Cloud — virtual servers in the cloud. Choose instance types, AMIs, and storage.',
        topics: ['Instance types', 'AMI', 'Security Groups', 'EBS volumes'],
      },
      {
        icon: '⚡',
        title: 'Lambda',
        level: 'intermediate',
        description: 'Serverless compute — run code without managing servers. Event-driven, pay-per-invocation.',
        topics: ['Triggers', 'Layers', 'Cold starts', 'Concurrency'],
      },
      {
        icon: '📦',
        title: 'ECS & EKS',
        level: 'intermediate',
        description: 'Container orchestration on AWS. ECS is AWS-native; EKS is managed Kubernetes.',
        topics: ['Fargate', 'Task definitions', 'Service mesh', 'Node groups'],
      },
    ],
  },
  {
    title: 'Storage & Databases',
    icon: '🗄️',
    cards: [
      {
        icon: '🪣',
        title: 'S3',
        level: 'beginner',
        description: 'Object storage with 11 nines durability. Versioning, lifecycle rules, events, and access control.',
        topics: ['Buckets', 'ACLs', 'Lifecycle', 'S3 Events'],
      },
      {
        icon: '🗃️',
        title: 'RDS & Aurora',
        level: 'intermediate',
        description: 'Managed relational databases. RDS supports MySQL/Postgres/Oracle; Aurora is AWS-optimized.',
        topics: ['Multi-AZ', 'Read replicas', 'Parameter groups', 'Snapshots'],
      },
      {
        icon: '⚡',
        title: 'DynamoDB',
        level: 'intermediate',
        description: 'Serverless NoSQL database. Single-digit ms latency at any scale with flexible data modeling.',
        topics: ['Partition key', 'GSI/LSI', 'DAX', 'Streams'],
      },
      {
        icon: '🧠',
        title: 'ElastiCache',
        level: 'intermediate',
        description: 'Managed Redis/Memcached for caching, sessions, leaderboards, and pub/sub messaging.',
        topics: ['Redis Cluster', 'Pub/Sub', 'Persistence', 'Replication'],
      },
    ],
  },
  {
    title: 'Networking',
    icon: '🌐',
    cards: [
      {
        icon: '🔒',
        title: 'VPC',
        level: 'intermediate',
        description: 'Virtual Private Cloud — isolated network with subnets, route tables, gateways, and peering.',
        topics: ['Subnets', 'NAT Gateway', 'VPC Peering', 'PrivateLink'],
      },
      {
        icon: '⚖️',
        title: 'Load Balancers',
        level: 'intermediate',
        description: 'ALB (HTTP/HTTPS), NLB (TCP/UDP), and CLB. Distribute traffic, perform health checks.',
        topics: ['ALB', 'NLB', 'Target groups', 'Health checks'],
      },
      {
        icon: '🌍',
        title: 'Route 53 & CloudFront',
        level: 'intermediate',
        description: 'DNS management and global CDN. Route 53 supports weighted, latency, and failover routing.',
        topics: ['Hosted zones', 'Routing policies', 'CloudFront origins', 'OAI'],
      },
    ],
  },
  {
    title: 'Security & DevOps',
    icon: '🔐',
    cards: [
      {
        icon: '👤',
        title: 'IAM',
        level: 'beginner',
        description: 'Identity and Access Management. Users, roles, policies, and the principle of least privilege.',
        topics: ['Policies', 'Roles', 'STS', 'Policy simulator'],
      },
      {
        icon: '🔑',
        title: 'Secrets Manager & KMS',
        level: 'intermediate',
        description: 'Store and rotate secrets automatically. KMS manages encryption keys for AWS services.',
        topics: ['Secret rotation', 'CMK', 'Envelope encryption', 'Key policies'],
      },
      {
        icon: '🚀',
        title: 'CodePipeline & CDK',
        level: 'intermediate',
        description: 'CI/CD with CodeBuild, CodeDeploy, and CodePipeline. CDK for infrastructure as code in TypeScript/Python.',
        topics: ['Stages', 'CodeBuild', 'CloudFormation', 'CDK Constructs'],
      },
    ],
  },
];

function AWS() {
  return (
    <TopicPage
      title="AWS"
      subtitle="Amazon Web Services — cloud infrastructure, storage, databases, and DevOps at scale."
      icon="☁️"
      color="#ff9900"
      sections={sections}
    />
  );
}

export default AWS;
